var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{attrs:{"small":"","color":"white","text-color":"white","close":_setup.hasCloseEvent},on:{"click:close":function($event){return _setup.emits('closeEvent')}}},[_vm._v(" "+_vm._s(_vm.$t(_setup.props.value))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }